export default __webpack_public_path__ + "static/media/404_page_not_found.ac2f4251.svg";